import { render, staticRenderFns } from "./MemberEmailButton.vue?vue&type=template&id=45778f54&scoped=true&"
import script from "./MemberEmailButton.vue?vue&type=script&lang=js&"
export * from "./MemberEmailButton.vue?vue&type=script&lang=js&"
import style0 from "./MemberEmailButton.vue?vue&type=style&index=0&id=45778f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45778f54",
  null
  
)

export default component.exports